export const theme = {
  'primary': '#3274F9'
}
